<button class='avano-button-bar-help-button'>
  <span>Help</span>
</button>
